import React from "react";
import { Card, Dimmer, Loader, Segment, Button, Grid } from "semantic-ui-react";
import SingleItem from "../SingleItem/SingleItem";
import "./SingleItemList.css";
import classNames from "classnames";

const SingleItemList = (props) => {
 const{ boxItems: singleBoxItems,
  cartItems,
  getNextSortBoxCallback,
  crateId,
  isLoading,
  refreshCallback,
  manualSkuCallback,
  currentSortBoxID,
  missingCallback,
  infoBarHeight,
  rxMode = false
} = props;
  const classes = classNames({
    CartItemsDiv: true,
    flexGrow: true,
  });

  const _switchToNonSingleShelf = () => {
    const nonSingleCartItems = cartItems.filter(
      (x) => x.shelfNumber !== "51" && x.shelfNumber !== "A"
    );
    if (nonSingleCartItems.length > 0 && getNextSortBoxCallback !== null) {
      const box = nonSingleCartItems[0];
      getNextSortBoxCallback(null, box.shelfNumber);
    }
  };

  const heightStyle = { height: ` calc(100vh - ${infoBarHeight + 60}px)` };

  return (
    <Segment style={heightStyle} className={classes}>
      <Dimmer active={isLoading} inverted>
        <Loader size="big" />
      </Dimmer>
      {cartItems?.some((x) => x.shelfNumber !== "51" && x.shelfNumber !== "A" && getNextSortBoxCallback) > 0 ? (
        <Button
          style={{ width: "100%" }}
          color="yellow"
          visible="false"
          onClick={_switchToNonSingleShelf}
        >
          GÅ TILL ÖVRIGA FACK
        </Button>
      ) : null}
      <Grid columns={2}>
        {!rxMode ? (<Grid.Row className="CartItemsHeader"></Grid.Row> ) : null}
        <Grid.Row className="CartItemsHeader" color={"grey"}>
          <Grid.Column width={13} textAlign="left">
            Innehåll i singellåda {crateId}
          </Grid.Column>
          <Grid.Column width={3}>
          {!rxMode ? (<Button size="tiny" circular icon="refresh" color="teal" onClick={refreshCallback} />):null}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Card.Group itemsPerRow={1} className="CardItemsGroup">
            {singleBoxItems.map((oi, i) => (
              <SingleItem
                key={i}
                isCurrent={oi.boxID === currentSortBoxID}
                manualSkuCallback={manualSkuCallback}
                missingCallback={missingCallback}
                boxItem={oi}
              />
            ))}
          </Card.Group>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default SingleItemList;
